<template>
  <div
    class="d-flex justify-content-between align-items-center bg-extra-light-gray rounded p-3 mb-3"
  >
    <div class="d-flex flex-column">
      <h5 class="mb-0 font-weight-bold">
        {{
          `
          ${portalAccess.name} 
          ${portalAccess.relationship ? `(${portalAccess.relationship})` : ""}
          `
        }}

        <small style="font-size:0.6em;" class="d-block mt-1 font-weight-normal">
          {{ portalAccess.email }}
        </small>
        <small
          style="font-size:0.6em;"
          v-if="portalAccessError"
          class="d-block mt-1 font-weight-normal text-danger"
        >
          {{ portalAccessError }}
        </small>
      </h5>
    </div>

    <vue-toggles
      height="30"
      width="88"
      :checkedText="!portalAccessError ? 'Granted' : ''"
      :uncheckedText="!portalAccessError ? 'Disabled' : ''"
      checkedBg="#34C759"
      :uncheckedBg="!portalAccessError ? '#FF6161' : '#CCC'"
      :disabled="portalAccessError ? true : false"
      :value="portalAccessError ? false : portalAccess.status == 'Enabled'"
      @click="handleSwitchAction(portalAccess)"
    />
  </div>
</template>

<script>
export default {
  name: "EocPortalAccessCard",
  props: ["portalAccess", "otherAccesses"],
  methods: {
    handleSwitchAction(item) {
      this.$emit("switchChange", item);
    }
  },
  computed: {
    portalAccessError() {
      if (!this.portalAccess.email) {
        this.$emit("switchChange", this.portalAccess, false);
        return "NO EMAIL ON RECORD (Add an email in order to grant Portal Access)";
      }
      if (
        this.otherAccesses
          .map(pA => pA.email)
          .indexOf(this.portalAccess.email) >= 0
      ) {
        return "Email must be unique";
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
